import Axios, { CancelTokenSource } from 'axios'
import { getPathName, getApiHash, getApiToken } from './helper';

const cotizar = async (compania: string, idContacto: string, emisionHabilitada: string, token: string, cancelTokenSource: CancelTokenSource) => {
    const params = {
        hash: await getApiHash(),
        compania: compania,
        idContacto: idContacto,
        emisionHabilitada: emisionHabilitada,
        token: token,
    }
    const headers = {
        'content-type': 'application/json',
        "Authorization": 'Bearer ' + await getApiToken()
    }


    let endpoint = "/getproductosjson"
    if (process.env.REACT_APP_DEV_MODE === "true") {
        if (process.env.REACT_APP_PAIS == "uy") endpoint = "/getproductosvehiculojson"
    } else {
        const hostname = window.location.hostname;
        if (hostname.endsWith(".com.uy")) {
            endpoint = "/getproductosvehiculojson"
        } else {
            endpoint = "/getproductosjson"
        }
    }

    return await Axios.post(await getPathName() + endpoint + "?random=" + (Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000), params,
        {
            headers: headers,
            cancelToken: cancelTokenSource.token,
        }).then(function (response) {
            return response;
        }).catch(function (error) {
            // Manejar el error aquí
            if (Axios.isCancel(error)) {
                // La solicitud fue cancelada
            } else {
                // Otro error de la solicitud
                console.error('Error en la solicitud', error);
            }
            return error
        });
};

export default cotizar;